import Nullstack from 'nullstack';
export default function IconGitFork({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-git-fork",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "18",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "7",
    cy: "6",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "17",
    cy: "6",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M7 8v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-2"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "12",
    x2: "12",
    y2: "16"
  }), " ");
}